import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

const Container = styled.div`
  padding: 10px;
`

const PageTitle = styled.h3`
  margin: 0;
  padding: 0;
`

const Subtitle = styled.div`
  font-size: 12px;
`

export default function Title({ title, subtitle }) {
  return (
    <Container>
      <PageTitle>
        {title}
      </PageTitle>
      <Subtitle>
        {subtitle}
      </Subtitle>
    </Container>
  )
}

Title.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
}

Title.defaultProps = {
  subtitle: '',
}
